//Reference: EN056

import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class Entity extends Mappeable {

    idEntityPk: number;
    txtName: string;
    txtDescription: string;
    entamap: any;
    country: any;
    currency: any;
    typeOrganizationalStructure: any
    mrkActive: boolean;
    dateInsert: string;
    dateUpdate: string;
    userInsert: string;
    userUpdate: string;
    organizationalStructure: any;
    businessUnit:any;
    size: number;
    importance: number;
    hfmCode: string;

    constructor(o) {
        super(o);
        this.typeOrganizationalStructure = this.typeOrganizationalStructure ??  null 
        this.currency = this.currency ??  {} 
        this.country = this.country ??  {} 
        this.organizationalStructure = _.isUndefined(this.organizationalStructure) || _.isNull(this.organizationalStructure) ? {} : this.organizationalStructure.idOrganizationalStructurePk;
        this.businessUnit = this.businessUnit ??  [] 
        this.entamap = _.isUndefined(this.entamap) || _.isNull(this.entamap) || this.entamap === '' ? null : this.entamap;
        this.mrkActive = this.mrkActive ??  false 
    }

    public mapToBack() {
        return {
            country: this.country,
            currency: this.currency,
            mrkActive: this.mrkActive,
            entamap: this.entamap,
            typeOrganizationalStructure: this.typeOrganizationalStructure,
            txtName: this.txtName,
            txtDescription: "Default",
            organizationalStructure: this.organizationalStructure,
            businessUnit: this.businessUnit,
            size: this.size,
            hfmCode: this.hfmCode
        }
    }
}